export default __webpack_public_path__ + "static/media/sergon.a02f72d3.jpg";